"use client";
import React, { FC } from "react";

interface Props {
  explanation: string;
}
export const EducationalExplanation: FC<Props> = ({ explanation }) => {
  return (
    <div className="bg-gradient-to-r from-blue-500/20 to-brand-teal/20 rounded-xl p-4 border border-blue-500/30">
      <h4 className="text-lg font-bold mb-3 text-blue-300">
        🧠 The Science Behind This
      </h4>
      <p className="text-sm text-gray-300 leading-relaxed">{explanation}</p>
    </div>
  );
};
